module.exports = __webpack_public_path__ + "img/k1@2x.63be20b9.png";